export const DATE_FORMAT = 'YYYY/MM/DD';
export const DATE_FORMAT_2 = 'YYYY-MM-DD';
